import { render } from "./ContactPersonForm.vue?vue&type=template&id=3c4d8de2&scoped=true"
import script from "./ContactPersonForm.vue?vue&type=script&lang=js"
export * from "./ContactPersonForm.vue?vue&type=script&lang=js"

import "./ContactPersonForm.vue?vue&type=style&index=0&id=3c4d8de2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4d8de2"]])

export default __exports__